import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AwsRum } from 'aws-rum-web';

// Import i18n (must be before App)
import '@nohara-dxdev/react-core';

import './index.css';

import { App } from './app';
import { env } from './config/env';

// RUM env vars are only set when monitoring is enabled for this stage (prod/stage).
// Init errors are swallowed so a RUM outage never breaks the app itself.
if (env.RUM_APP_MONITOR_ID && env.RUM_IDENTITY_POOL_ID && env.RUM_REGION) {
  try {
    new AwsRum(env.RUM_APP_MONITOR_ID, '1.0.0', env.RUM_REGION, {
      identityPoolId: env.RUM_IDENTITY_POOL_ID,
      endpoint: `https://dataplane.rum.${env.RUM_REGION}.amazonaws.com`,
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      sessionSampleRate: 1,
    });
  } catch {
    // ignore RUM init errors
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
